import SingleOrganizationRoute from './SingleOrganizationRoute';

export default SingleOrganizationRoute;
